module.exports = {"general":{"no_data":"Not found data","add":"Add","back":"Back"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = yZm8
// module chunks = 41